/**
 * Guest session management utilities
 * Generates and persists a unique session ID for guest users
 */

const SESSION_STORAGE_KEY = 'guest_session_id';

/**
 * Generate a UUID v4
 */
function generateUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : ((r & 0x3) | 0x8);
    return v.toString(16);
  });
}

/**
 * Get or create a guest session ID
 * Persists in localStorage for continuity across page reloads
 */
export function getGuestSessionId(): string {
  let sessionId = localStorage.getItem(SESSION_STORAGE_KEY);
  
  if (!sessionId) {
    sessionId = generateUUID();
    localStorage.setItem(SESSION_STORAGE_KEY, sessionId);
  }
  
  return sessionId;
}

/**
 * Clear the guest session ID
 * Should be called when user signs up/logs in
 */
export function clearGuestSessionId(): void {
  localStorage.removeItem(SESSION_STORAGE_KEY);
}
